var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_7637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6438 16.4157C22.1982 15.4583 23.0926 15.4583 23.647 16.4157L27.0989 22.4756C27.6533 23.4331 27.1997 24.2142 26.0911 24.2142H19.1367C18.0407 24.2142 17.5871 23.4331 18.1289 22.4756L21.6438 16.4157ZM14.9667 4.7496C15.521 3.79212 16.4029 3.79212 16.9572 4.7496L17.7257 6.13543L19.5399 9.32283C19.9808 10.2299 19.9808 11.3008 19.5399 12.2079L13.4549 22.7528C12.9005 23.6094 11.9808 24.1512 10.9604 24.2142H5.9084C4.79974 24.2142 4.34619 23.4457 4.90053 22.4756L14.9667 4.7496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_7637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/AVAX.4e2b195d311fa256396ae575a33483db.svg";
export { ForwardRef as ReactComponent };